import _ from 'lodash';
import Rx from 'ub_wrapped/rx';

import SVGActions from './svg-actions';

const svgActionsSubject = new Rx.Subject();
const stateChangedSubject = new Rx.Subject();

let currentState = {};

stateChangedSubject.subscribe((newState) => {
  currentState = newState;
});

svgActionsSubject
  .filter((ev) => { return !_.isEmpty(ev.type); })
  .subscribe((ev) => {
    const newState = SVGActions[ev.type](currentState, ev.value, ev);

    stateChangedSubject.onNext(newState);
  });

export default {
  stateChangedSubject,
  svgActionsSubject
};



// WEBPACK FOOTER //
// ./src/ui/svg/state-controller.js